module.exports = __webpack_public_path__ + "static/img/jdown.a978b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jdown.png
// module id = ETv+
// module chunks = 4